var RCEConfigBuilder = /** @class */ (function () {
    function RCEConfigBuilder(experiments, initialState) {
        if (initialState === void 0) { initialState = []; }
        this.experiments = experiments;
        this.entries = new Set(initialState);
    }
    RCEConfigBuilder.prototype.add = function (entry, experiments) {
        var _this = this;
        if ((experiments &&
            experiments.some(function (experimentName) {
                return _this.experiments.enabled(experimentName);
            })) ||
            !experiments) {
            this.entries.add(entry);
        }
        return this;
    };
    RCEConfigBuilder.prototype.delete = function (entry, experimentName) {
        if ((experimentName && this.experiments.enabled(experimentName)) ||
            !experimentName) {
            this.entries.delete(entry);
        }
        return this;
    };
    RCEConfigBuilder.prototype.build = function () {
        return Array.from(this.entries);
    };
    return RCEConfigBuilder;
}());
export { RCEConfigBuilder };
//# sourceMappingURL=RCEConfigBuilder.js.map